var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: (_vm.prefixCls + "-btn-group " + _vm.prefixCls + "-radio-group")
  }, [_vm._t("default"), _vm._v(" "), _c('validate', {
    attrs: {
      "name": _vm.name,
      "rules": _vm.rules,
      "custom-validate": _vm.customValidate,
      "current": _vm.value
    }
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2ad0c767", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ad0c767"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Radio/n3RadioGroup.vue
// module id = 608
// module chunks = 0 1